/**
 * Object class to handle functionality for condensing menu links into an
 * artifitial "More" sub-navigation.
*/
var NavigationCondenser = {
  // ID of menu element to target.
  menu_id: "",
  // Minimum length of menu items to trigger condensing.
  minimum_menu_size: 6,
  // Last menu item to leave uncondensed.
  last_uncondensed_item: 4,
  // Internal storage of inital size of menu.
  menu_size: 0,
  // Internal hard-coded id/class names, to minimize repeated strings.
  navbar_toggler_class: '.navbar-toggler',
  condensed_subnav_name: 'condense-navigation-subnav',
  subnav_menu_item_name: 'menu-item-subnav',
  condensed_button_name: 'condense-nav-button',
  kd_event: null,

  /**
   * Initalization of the object settings.
   *
   * @param {string} menu_id (optional) ID of menu to target
   * @param {number} minimum_menu_size (optional) Minimum number of menu items.
   */
  init: function(menu_id = "", minimum_menu_size = 6) {
    // Create new event object keypress tracking.
    this.kd_event = new Event('keydown');
    // Set the menu id.
    this.setMenuId(menu_id);
    // Set the link limit.
    this.setMinimumMenuSize(minimum_menu_size);
    // Get the inital length of the menu.
    this.menu_size = this.getMenuSize();
    // Calculate the last uncondensed menu item.
    this.setLastUncondensedItem(minimum_menu_size);
  },

  /**
   * Calculare the last menu item to be left uncondensed.
   */
  setLastUncondensedItem: function() {
    // Initalize to 0 (first menu item).
    last_uncondensed_item = 0;

    // If minimum menu size is greater than 2, then calculate. (else leave 0).
    if (this.minimum_menu_size > 2) {
      // Set to the minimum length minus 2.
      last_uncondensed_item = (this.minimum_menu_size - 2);
    }
    // Set the global property.
    this.last_uncondensed_item = last_uncondensed_item;
  },

  /**
   * Set status of debug settings.
   *
   * @param {boolean} status boolean status of debug state.
   */
  setDebug: function(status = false) {
    this.debug = (status === true);
  },

  /**
   * Set id value for menu to target.
   *
   * @param {string} menu_id Id string for menu to target.
   */
  setMenuId: function(menu_id) {
    this.menu_id = menu_id;
  },

  /**
   * Set minimum limit for enabling condenser.
   *
   * @param {number} minimum_menu_size Minimum size of menu.
   */
  setMinimumMenuSize: function(minimum_menu_size) {
    this.minimum_menu_size = minimum_menu_size;
  },

  /**
   * Add jQuery events to trigger the open/close of the condensed menu.
   */
  setCondenserControls: function () {
    // Check that the button for triggering the condensed button exists.
    if (jQuery('#' + this.condensed_button_name).length) {
      // Add action on click.
      jQuery('#' + this.condensed_button_name).on("click.condensedMenuButton", (e) => {
        e.preventDefault();
        NavigationCondenser.toggleCondensedMenu();
      });

      // Add action on mouseover for parent li element.
      jQuery('#' + this.subnav_menu_item_name).on("mouseover", (e) => {
        NavigationCondenser.openCondensedMenu();
      });

      // Add action on mouseout of parent li element.
      jQuery('#' + this.subnav_menu_item_name).on("mouseout", (e) => {
        NavigationCondenser.closeCondensedMenu();
      });

      // Add action on focused keypress.
      jQuery('#' + this.condensed_button_name).on("keydown.condensedMenuButton", (e) => {
        // Capture keydown event for focusout event.
        this.kd_event.which = e.which;
        this.kd_event.shiftKey = e.shiftKey;
        var is_open = NavigationCondenser.isCondensedMenuExpanded();

        // If the enter key was pressed.
        if (e.which == 13) {
          e.preventDefault();
          NavigationCondenser.toggleCondensedMenu(true);
        } else if (e.which == 9 && e.shiftKey && is_open) {
          // If Shift + Tab keys pressed when at root close menu.
          NavigationCondenser.toggleCondensedMenu();
        }
      });

      // Add action focusout
      jQuery('#condense-navigation-subnav li:last-child').on("focusout", (e) => {
        // Close the nav menu when the last menu loses focus.
        is_open = NavigationCondenser.isCondensedMenuExpanded();
        if (this.kd_event.which == 9 && !this.kd_event.shiftKey && is_open) {
          NavigationCondenser.closeCondensedMenu();
        }
      });

      // Listen to keydown event on sub-menu.
      jQuery("#condense-navigation-subnav").on("keydown", (e) => {
        // Capture keydown event for focusout event.
        this.kd_event.which = e.which;
        this.kd_event.shiftKey = e.shiftKey;
      });

    }
  },

  /**
   * Return array of <li> chuldren found in a menu element.
   *
   * @param {string} menu_id (optional) Id of menu element to check.
   * @returns {array} Array of <li> children elements in the menu.
   */
  getMenuListItems: function (menu_id = "") {
    // Initalize empty array.
    list_items = [];
    // If no menu_id is provided, use the one set for the instance.
    if (!menu_id) {
      menu_id = this.menu_id;
    }

    // If have a menu id and the element exists.
    if (menu_id && jQuery("#" + menu_id).length) {
      // Get array of all children <li> element.
      list_items = jQuery("#" + menu_id).children('li');
    }
    // Return the array of found items.
    return list_items;
  },

  /**
   * Return length of menu.
   *
   * @param {string} menu_id (optional) Id of menu element.
   * @returns {number} Number of found items.
   */
  getMenuSize: function (menu_id = "") {
    // Initialize to 0.
    menu_size = 0;
    // If not provided a menu id and instance menu_size is set.
    if (!menu_id && this.menu_size) {
      // Assume we want the already stored size.
      menu_size = this.menu_size;
    }
    else {
      // Get array of list items for menu_id.
      list_items = this.getMenuListItems(menu_id);
      // Calculate the size based on length of items.
      menu_size = list_items.length;
    }

    return menu_size;
  },

  /**
   * Returns true/false if menu is big enough to condense.
   *
   * @param {string} menu_id (optional) Id of menu element to check.
   * @returns {boolean} True/false
   */
  isMenuLargeEnough: function (menu_id = "") {
    // Return true is length of menu is equal or greater then the minimum.
    return (this.getMenuSize(menu_id) >= this.minimum_menu_size);
  },

  /**
  * Returns status if menu allows for condensing.
  *
  * @returns {boolean} true if condensing is allowed, else false.
  */
  isCondensingAllowed: function () {
    // True only if user is on desktop and menu is large enough
    return (this.isDesktop() && this.isMenuLargeEnough());
  },

  /**
   * Returns boolena state of condensed menu.
   *
   * @returns {boolean} true if expanded, else false.
   */
  isCondensedMenuExpanded: function () {
    // Initialize as false.
    is_expanded = false;
    // Check if condensed menu toggle button exists.
    if (jQuery('#' + this.condensed_button_name).length) {
      // Get current aria-expanded value. true/false.
      is_expanded = (jQuery('#' + this.condensed_button_name).attr('aria-expanded') == 'true');
    }

    return is_expanded;
  },

  /**
   * Returns status if menu is already condensed.
   *
   * @returns {boolean} true if condenser toggle is present.
   */
  isCondensed: function () {
    // Check to see if the condense navigation toggle exists or not.
    return (jQuery('#' + this.condensed_subnav_name).length > 0);
  },

  /**
   * Returns status if user is viewing on desktop or not.
   *
   * @returns {boolean} Returns true or false.
   */
  isDesktop: function () {
    var is_desktop = false;
    // Check for nav toggler use use as a metric.
    if (jQuery(this.navbar_toggler_class).length > 0) {
      // Return opposite if it is visible or not. If not visible, that means desktop.
      is_desktop = !jQuery(this.navbar_toggler_class).is(':visible')
    }

    return is_desktop;
  },

  /**
   * Enables / Disables condensed menu.
   */
  toggleCondenser: function() {
    // Determine if on Desktop  and not already condensed.
    if (this.isCondensingAllowed() && !this.isCondensed()) {
      // Enable the condenser.
      this.enableCondenser();
    }
    // If not allowed and is consensed.
    else if (!this.isCondensingAllowed() && this.isCondensed()) {
      // Disable the condensed menu to reset the inital one.
      this.disableCondenser();
    }
  },

  /**
   * Toggles open/closed condensed menu.
   *
   * @param {boolean} set_focus (optional) change focus to sub-element.
   */
  toggleCondensedMenu: function (set_focus = false) {
    // If the condensed menu is already expanded, then close it.
    if (this.isCondensedMenuExpanded()) {
      this.closeCondensedMenu();
    }
    // Else menu is not expanded, so open it.
    else {
      this.openCondensedMenu(set_focus);
    }
  },

  /**
   * Condense all menu items past defined limit.
   */
  enableCondenser: function() {
    // Check if is not already condensed.
    if (!this.isCondensed()) {
      // Get all of the li's in the navigation.
      list_items = this.getMenuListItems();
      // Get the last item to remain uncondensed.
      last_item = list_items.eq(this.last_uncondensed_item - 1);
      // Create a new list item.
      jQuery('<li id="' + this.subnav_menu_item_name + '" class="menu-item ' + this.subnav_menu_item_name + '"></li>')
        // Add it to the list after the last non-condensed item.
        .insertAfter(last_item);
      // Add a new toggle button.
      jQuery('<a href="#" role="button" id="' + this.condensed_button_name + '" class="' + this.condensed_button_name + '" aria-label="Show additional menu items" aria-expanded="false" aria-controls="' + this.condensed_subnav_name + '">More</a>')
        .appendTo('#' + this.subnav_menu_item_name);
      // Add a new <ul> to hold moved links.
      jQuery('<ul id="' + this.condensed_subnav_name + '" class="' + this.condensed_subnav_name + '"></ul>')
        .appendTo('#' + this.subnav_menu_item_name);
      // Move all list_items greater then the limit into subnav.
      for (var i = this.last_uncondensed_item; i < list_items.length; i++) {
        // Get the list item to condense
        condense_item = list_items.eq(i);
        // Set tabindex to -1 for all children links, since they will be hidden.
        condense_item.children('a').attr('tabindex', '-1');
        // Append to the subnav list.
        condense_item.appendTo('#' + this.condensed_subnav_name);
      }
      // Get osition directly below parent list item with no gaps.
      height_offset = jQuery('#' + this.subnav_menu_item_name).offset().top + jQuery('#' + this.subnav_menu_item_name).height();
      // Need to remove height of admin bar if it is there.
      if (jQuery('#wpadminbar').length) {
        height_offset = height_offset - jQuery('#wpadminbar').height();
      }
      // Position sub nav directly below it.
      jQuery('#' + this.condensed_subnav_name).css('top', height_offset - 1);
      //Add toggle controls for expanding/collapsing.
      this.setCondenserControls();
    }
  },

  /**
   * Reset menu back to how it was and remove condenser functionality.
   */
  disableCondenser: function () {
    // Check if is currently condensed.
    if (this.isCondensed()) {
      // Get all of the li's in the navigation.
      var list_items = this.getMenuListItems();
      // Get all of the li's in the sub-navigation
      var sub_items = this.getMenuListItems(this.condensed_subnav_name);
      if (sub_items.length > 0) {
        // Get the last item to remain uncondensed.
        last_item = list_items.eq(this.last_uncondensed_item - 1);
        // Loop through each sub-nav links backwards.
        for (var s = (sub_items.length - 1); s >= 0; s--) {
          // Get the menu item to un-condense
          condensed_item = sub_items.eq(s);
          // Remove the tabindex attribute from all child links.
          condense_item.children('a').removeAttr('tabindex');
          // Append back to the main navigation after the last uncondensed one.
          condense_item.insertAfter(last_item);
        }
      }
      // Remove the sub-nav.
      jQuery('#' + this.subnav_menu_item_name).remove();
    }
  },

  /**
   * Opens the condensed menu.
   *
   * @param {booelan} set_focus (optional) boolean to reset focus.
   */
  openCondensedMenu: function(set_focus = false) {
    // Check if not already expanded.
    if (!this.isCondensedMenuExpanded()) {
      // Get all sub-nav menu items.
      var sub_items = this.getMenuListItems(this.condensed_subnav_name);
      // If have sub_items.
      if (sub_items.length > 0) {
        // Loop through each sub nav item.
        for (var s=0;s < sub_items.length; s++) {
          // Set Tabindex to 0 for all child links.
          sub_items.eq(s).children('a').attr('tabindex', '0');
        }
      }
      // Add 'open' class to subnav list to display.
      jQuery('#' + this.condensed_subnav_name).addClass('open');
      // Set aria-expanded on button to true.
      jQuery('#' + this.condensed_button_name).attr('aria-expanded', 'true');

      //create a named function to remove the event listener.
      const closeCondensedOnEsc = (e) => {
        if (e.which == 27) {
          this.closeCondensedMenu();
        }
      }
      document.addEventListener('keydown', closeCondensedOnEsc);
      // Store the function in as an attribute of the document.
      document.condensed_menu_closer = closeCondensedOnEsc;
      // If we want to set focus and the are sub_items.
      if (set_focus && sub_items.length) {
        // Set focus to the first subnav element.
        sub_items.eq(0).children('a:first-child').focus();
      }
    }
  },

  /**
   * Closes the condensed menu.
   */
  closeCondensedMenu: function() {
    // Check if is already expanded.
    if (this.isCondensedMenuExpanded()) {
      // Remove 'open' class from subnav.
      jQuery('#' + this.condensed_subnav_name).removeClass('open');
      // Set aria-expanded on button to false.
      jQuery('#' + this.condensed_button_name).attr('aria-expanded', 'false');
      // Recall the named function to remove the event listener.
      document.removeEventListener('keydown', document.condensed_menu_closer);
      // Remove the saved reference to the function.
      document.condensed_menu_closer = null;
      // Get all sub-nav menu items.
      var sub_items = this.getMenuListItems(this.condensed_subnav_name);
      if (sub_items.length > 0) {
        // Loop through each sub nav item.
        for (var s = 0; s < sub_items.length; s++) {
          // Set Tabindex to -1 for all child links.
          sub_items.eq(s).children('a').attr('tabindex', '-1');
        }
      }
    }
  }
}

// Wait for DOM to be fully loaded.
jQuery(function() {

  // Initialize on the navigation menu, with 6 links.
  NavigationCondenser.init("menu-top-navigation-menu", 6);

  // Toggle Condenser
  NavigationCondenser.toggleCondenser();

  // Add trigger on window resizing.
  jQuery(window).resize(function(){
    NavigationCondenser.toggleCondenser();
  });

  // Close the mobile nav menu when the menu loses focus.
  if (NavigationCondenser.isDesktop() == false ) {
    document.querySelector('#menu-top-navigation-menu>.menu-item:last-child').addEventListener('keydown', function(e) {
      if (e.which == 9 && !e.shiftKey ) {
        document.querySelector('button.navbar-toggler').click();
      }
    });
  }

});
